<script lang="ts">
  import IconCalendar from "../assets/IconCalendar.svelte";
  import IconClipboardList from "../assets/IconClipboardList.svelte";
  import IconCog from "../assets/IconCog.svelte";
  import IconCreditCard from "../assets/IconCreditCard.svelte";
  import IconDatabase from "../assets/IconDatabase.svelte";
  import IconHeart from "../assets/IconHeart.svelte";
  import IconHome from "../assets/IconHome.svelte";
  import IconLogout from "../assets/IconLogout.svelte";
  import IconMail from "../assets/IconMail.svelte";
  import IconMap from "../assets/IconMap.svelte";
  import IconOfficeBuilding from "../assets/IconOfficeBuilding.svelte";
  import IconPaperAirplane from "../assets/IconPaperAirplane.svelte";
  import IconShare from "../assets/IconShare.svelte";
  import IconDocumentSearch from "../assets/IconDocumentSearch.svelte";
  import IconDocumentAdd from "../assets/IconDocumentAdd.svelte";
  import IconDocumentText from "../assets/IconDocumentText.svelte";
  import IconStar from "../assets/IconStar.svelte";
  import IconPause from "../assets/IconPause.svelte";
  import IconMinus from "../assets/IconMinus.svelte";
  import IconCurrencyDollar from "../assets/IconCurrencyDollar.svelte";
  import IconTruck from "../assets/IconTruck.svelte";
  import IconLocationMarker from "../assets/IconLocationMarker.svelte";
  import IconUser from "../assets/IconUser.svelte";
  import IconX from "../assets/IconX.svelte";
  import IconPhone from "../assets/IconPhone.svelte";
  import IconEye from "../assets/IconEye.svelte";

  export let name = "";
  export let title: string = undefined;

  const options = {
    heart: IconHeart,
    database: IconDatabase,
    cog: IconCog,
    clipboardList: IconClipboardList,
    home: IconHome,
    logout: IconLogout,
    mail: IconMail,
    calendar: IconCalendar,
    map: IconMap,
    creditCard: IconCreditCard,
    share: IconShare,
    officeBuilding: IconOfficeBuilding,
    paperAirplane: IconPaperAirplane,
    documentSearch: IconDocumentSearch,
    documentAdd: IconDocumentAdd,
    documentText: IconDocumentText,
    star: IconStar,
    pause: IconPause,
    minus: IconMinus,
    currencyDollar: IconCurrencyDollar,
    truck: IconTruck,
    locationMarker: IconLocationMarker,
    user: IconUser,
    x: IconX,
    phone: IconPhone,
    eye: IconEye,
  };
  $: selected = options[name];
</script>

<svelte:component this={selected} />
{#if title}
  <span class="ml-2" />{title}
{/if}
